import React from "react";
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { useI18n } from "@/i18n/I18nProvider";
import { formatBRL } from "./vipSimulatorUtils";

/**
 * @param {{
 *   open: boolean;
 *   onOpenChange: (open: boolean) => void;
 *   onConfirm: () => void;
 *   gapInfo: { gap: number; tierBudget: number; orderTotal: number; benefits: ({ pt: string, en: string } | string)[]; tierUnlocks: ({ pt: string, en: string } | string)[]; tierInheritsFrom?: number | null } | null;
 * }} props
 */
export default function BudgetGapDialog({ open, onOpenChange, onConfirm, gapInfo }) {
    const { t, l } = useI18n();
    if (!gapInfo) return null;

    const { gap, tierBudget, orderTotal, benefits, tierUnlocks, tierInheritsFrom } = gapInfo;

    return (
        <AlertDialog open={open} onOpenChange={onOpenChange}>
            <AlertDialogContent className="vip-sim-budget-gap-dialog">
                <AlertDialogHeader>
                    <AlertDialogTitle>{t("benefits.gap.title")}</AlertDialogTitle>
                    <AlertDialogDescription asChild>
                        <div className="vip-sim-budget-gap-dialog__body">
                            <p>
                                {t("benefits.gap.p1")}
                                <strong>{formatBRL(orderTotal)}</strong>
                                {t("benefits.gap.p2")}
                                <strong>{t("benefits.gap.tierAmount", { tier: tierBudget })}</strong>
                                {t("benefits.gap.p3")}
                                <strong>{formatBRL(gap)}</strong>
                                {t("benefits.gap.p4")}
                            </p>
                            {benefits.length > 0 ? (
                                <>
                                    <p className="vip-sim-budget-gap-dialog__lead">{t("benefits.gap.lead")}</p>
                                    <ul>
                                        {benefits.map((b, i) => (
                                            <li key={`${i}-${l(b)}`}>{l(b)}</li>
                                        ))}
                                    </ul>
                                </>
                            ) : null}
                            {tierUnlocks.length > 0 ? (
                                <>
                                    <p className="vip-sim-budget-gap-dialog__lead">
                                        {t("benefits.gap.includedIn", { tier: tierBudget })}
                                        {tierInheritsFrom != null
                                            ? t("benefits.gap.inheritsSuffix", { prev: tierInheritsFrom })
                                            : ":"}
                                    </p>
                                    <ul className="vip-sim-budget-gap-dialog__tier">
                                        {tierUnlocks.map((u, i) => (
                                            <li key={`${i}-${l(u)}`}>{l(u)}</li>
                                        ))}
                                    </ul>
                                </>
                            ) : null}
                            <p className="vip-sim-budget-gap-dialog__hint">{t("benefits.gap.hint")}</p>
                        </div>
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel>{t("benefits.gap.cancel")}</AlertDialogCancel>
                    <AlertDialogAction onClick={onConfirm}>
                        {t("benefits.gap.confirm", { tier: tierBudget })}
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
